import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap'; // Added Card
import { createFornitore, getFornitore } from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

const NuovoFornitore = () => {
  const initialFormData = {
    denominazione: '',
    codice_fiscale: '',
    partita_iva: '',
    indirizzo: '',
    cap: '',
    citta: '',
    provincia: '',
    nazione: 'ITALIA', // Default to ITALIA
    codice_destinatario: '',
    telefono: '',
    cellulare: '',
    email: '',
    pec: ''
  };

  const [formData, setFormData] = useState(initialFormData);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const duplicateId = queryParams.get('duplicateId');

    if (duplicateId) {
      const fetchFornitoreToDuplicate = async () => {
        try {
          const response = await getFornitore(parseInt(duplicateId));
          const duplicatedFornitore = response.data;

          // Clear unique fields and ID for duplication
          setFormData({
            ...duplicatedFornitore,
            id: undefined, // Ensure ID is not sent for new creation
            codice_fiscale: null, 
            partita_iva: null,
            email: null,
            pec: null,
            denominazione: duplicatedFornitore.denominazione ? `${duplicatedFornitore.denominazione} (Copia)` : null,
            // Other fields that should be unique or reset for a new record
          });
          // Optionally remove duplicateId from URL after processing
          navigate(location.pathname, { replace: true });
        } catch (error) {
          console.error("Errore durante il recupero del fornitore per la duplicazione:", error);
          alert("Errore durante il recupero dei dati per la duplicazione.");
        }
      };
      fetchFornitoreToDuplicate();
    }
  }, [location.search, navigate, location.pathname]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let newValue = value;

    if (name === 'cap' || name === 'provincia') {
      newValue = value.toUpperCase();
    }

    setFormData({
      ...formData,
      [name]: type === 'number' ? parseFloat(newValue) : newValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSubmit = { ...formData };

      // Convert empty strings to null for optional fields
      const optionalFields = [
        'codice_fiscale', 'partita_iva', 'indirizzo', 'cap', 'citta',
        'provincia', 'nazione', 'codice_destinatario', 'telefono',
        'cellulare', 'email', 'pec'
      ];

      optionalFields.forEach(field => {
        if (dataToSubmit[field] === '') {
          dataToSubmit[field] = null;
        }
      });

      await createFornitore(dataToSubmit);
      alert('Fornitore creato con successo!');
      navigate('/fornitori');
    } catch (error) {
      console.error('Errore nella creazione del fornitore:', error.response || error);
      alert('Errore nella creazione del fornitore.');
    }
  };

  return (
    <Container>
      <Row className="align-items-center mb-3">
        <Col>
          <h2>Nuovo Fornitore</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={() => navigate('/fornitori')} className="me-2">
            Torna alla Lista Fornitori
          </Button>
          <Button variant="primary" type="submit" form="fornitore-form">
            Salva Fornitore
          </Button>
        </Col>
      </Row>
      <Form id="fornitore-form" onSubmit={handleSubmit}>
        {/* Dati Anagrafici */}
        <Card className="mb-4">
          <Card.Header>Dati Anagrafici</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="formDenominazione">
              <Form.Label>Denominazione</Form.Label>
              <Form.Control type="text" name="denominazione" value={formData.denominazione} onChange={handleChange} required />
            </Form.Group>
            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="formCodiceFiscale">
                <Form.Label>Codice Fiscale</Form.Label>
                <Form.Control type="text" name="codice_fiscale" value={formData.codice_fiscale} onChange={handleChange} minLength="11" maxLength="16" />
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="formPartitaIva">
                <Form.Label>Partita IVA</Form.Label>
                <Form.Control type="text" name="partita_iva" value={formData.partita_iva} onChange={handleChange} minLength="11" maxLength="11" />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* Indirizzo */}
        <Card className="mb-4">
          <Card.Header>Indirizzo</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="formIndirizzo">
              <Form.Label>Indirizzo</Form.Label>
              <Form.Control type="text" name="indirizzo" value={formData.indirizzo} onChange={handleChange} placeholder="Via, Piazza, ecc."/>
            </Form.Group>
            <Row className="mb-3">
              <Form.Group as={Col} md={3} controlId="formCap">
                <Form.Label>CAP</Form.Label>
                <Form.Control type="text" name="cap" value={formData.cap} onChange={handleChange} minLength="5" maxLength="5" />
              </Form.Group>
              <Form.Group as={Col} md={5} controlId="formCitta">
                <Form.Label>Città</Form.Label>
                <Form.Control type="text" name="citta" value={formData.citta} onChange={handleChange} />
              </Form.Group>
              <Form.Group as={Col} md={2} controlId="formProvincia">
                <Form.Label>Provincia</Form.Label>
                <Form.Control type="text" name="provincia" value={formData.provincia} onChange={handleChange} minLength="2" maxLength="2" placeholder="XX"/>
              </Form.Group>
              <Form.Group as={Col} md={2} controlId="formNazione">
                <Form.Label>Nazione</Form.Label>
                <Form.Control type="text" name="nazione" value={formData.nazione} onChange={handleChange} />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* Contatti */}
        <Card className="mb-4">
          <Card.Header>Contatti</Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="formTelefono">
                <Form.Label>Telefono</Form.Label>
                <Form.Control type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="XXXX / XXXXXXXXX"/>
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="formCellulare">
                <Form.Label>Cellulare</Form.Label>
                <Form.Control type="tel" name="cellulare" value={formData.cellulare} onChange={handleChange} placeholder="XXXX / XXXXXXXXX" />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} placeholder="esempio@dominio.com" />
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="formPec">
                <Form.Label>PEC</Form.Label>
                <Form.Control type="email" name="pec" value={formData.pec} onChange={handleChange} placeholder="esempio@pec.it" />
              </Form.Group>
            </Row>
            <Form.Group className="mb-3" controlId="formCodiceDestinatario">
              <Form.Label>Cod. Destinatario (Fatt. Elettronica)</Form.Label>
              <Form.Control type="text" name="codice_destinatario" value={formData.codice_destinatario} onChange={handleChange} minLength="7" maxLength="7" />
            </Form.Group>
          </Card.Body>
        </Card>

      </Form>
    </Container>
  );
};

export default NuovoFornitore;
